<template>
  <div
    class="modal-level-two-container"
    v-if="forceReload"
    style="z-index: 99999999"
  >
    <Loading v-if="$store.state.modalStore.isLoading" />
    <div class="modal-dialog-level-two">
      <div class="modal-content-level-two">
        <div class="btn-modal-close cursor-pointer" @click="closeModal()">
          <i class="fa-solid fa-xmark"></i>
        </div>
        <div class="modal-header">
          <h4 class="modal-title">INUBBM</h4>
        </div>
        <div class="modal-filter-search">
          <InputIcons
            :inputClass="'border-input-red'"
            :placeholder="'Cari Bidang ...'"
            v-model="subSearch"
          />
        </div>
        <div class="modal-body-level-two" v-if="inubbmData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column40 mr10">Bidang</div>
          </div>
          <div class="horizontal" v-for="(item, index) in inubbm" :key="index">
            <div class="column5">
              <input
                class="modal-input-checkbox-level-two"
                type="checkbox"
                :id="index"
                :value="item"
                v-model="choose"
              />
            </div>
            <div class="column90 all-column">{{ item.desc }}</div>
          </div>
        </div>

        <div class="modal-body-level-two-mobile" v-if="inubbmData">
          <div
            class="modal-content-list"
            v-for="(item, index) in inubbm"
            :key="index"
          >
            <div class="column5 mr10">
              <input
                class="modal-input-checkbox-level-two"
                type="checkbox"
                :id="index"
                :value="item"
                v-model="choose"
              />
            </div>
            <div class="column90">
              <div class="w-full text-gray">Bidang</div>
              <div class="w-full">{{ item.desc }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer flex-space-between">
          <button type="button" class="btn btn__red" @click="add()">
            Done
          </button>
          <div class="btn btn__default">
            <BtnIcons
              :className="'level1-section-filter__footer-relative'"
              :path="'icon-refresh.png'"
              :title="'Reset'"
              :position="true"
              :colors="true"
              :onClick="onReset"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Loading: () => import('@/components/utils/Loading'),
    InputIcons: () => import('@/components/Atoms/InputIcons'),
    BtnIcons: () => import('@/components/Atoms/BtnIcons'),
  },
  data() {
    return {
      inubbm: [],
      choosedInubbm: [],
      subData: [],
      subSearch: '',
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function() {
        return this.$store.state.searchStore.choosedInubbm
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedInubbm',
          value: newValue,
        })
      },
    },
    inubbmData: async function() {
      return this.setUpData()
    },
  },
  watch: {
    subSearch: function(newValue, oldValue) {
      this.searchRun()
    },
  },
  methods: {
    async onReset() {
      this.$store.commit('searchStore/SET_SEARCH_VALUE', {
        name: 'choosedInubbm',
        value: [],
      })
    },
    async add() {
      console.log('subsearch done: ', this.subSearch)
      console.log('add Inubbm', this.$store.state.searchStore.choosedInubbm)
      await this.closeModal()
    },
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subData

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.inubbm = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      this.inubbm = this.subData
    },
    async setUpData() {
      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: true,
      })
      const getInubbm = await this.$getInubbm()
      const defaultInubbm = await this.$store.state.level1.choosedInubbm
      console.log('default inubbm: ', defaultInubbm)

      let reduceInubbm = await getInubbm.reduce(
        (a, b) => ({ ...a, [b.id]: b }),
        {}
      )

      let reduceDefault =
        (await defaultInubbm) &&
        defaultInubbm.reduce((a, b) => ({ ...a, [b.id]: b }), {})

      let combine = { ...reduceInubbm, ...reduceDefault }

      let newData = await Object.values(combine)

      this.inubbm = await newData.sort((a, b) => this.$sortAsc(a, b))
      this.subData = newData.sort((a, b) => this.$sortAsc(a, b))
      console.log('choosedInubbm setup: ', this.choosedInubbm)
      this.choosedInubbm = await defaultInubbm.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/setValue', {
        name: 'isLoading',
        value: false,
      })
    },
    closeModal() {
      this.$store.commit('modalStore/closeModal', {
        name: 'inubbm',
      })
    },
  },
}
</script>
